<template>
  <v-app>
    <div v-if="loaded">
      <button class="btn" @click="test">
        TEST auth (click)
      </button>
      <BR />
      {{ testMsg }}
      <BR />
      <h1>Hello {{ user.username }}</h1>
      <h1>Tenant {{ user.attributes.tenant }}</h1>
      <h1>---</h1>
      <h1>Hello {{ user }}</h1>
    </div>
  </v-app>
</template>

<script>
import Vue from "vue";
import { localhttp } from "../js/https-commons";

export default {
  name: "Protected",
  data: () => ({
    loaded: false,
    testMsg: "",
    user: null,
    tokeen: null
  }),
  async beforeCreate() {
    //redirection
    try {
      this.user = await Vue.$keycloak.loadUserProfile();
      this.loaded = true;
    } catch (err) {
      console.debug(err);
    }
  },
  methods: {
    async test() {
      await localhttp
        .get("/admin/test")
        .then(response => {
          if (response.data.length > 0) {
            this.testMsg = response.data;
          } else {
            this.testMsg = "ERROR";
          }
        })
        .catch(e => {
          console.log(e);
          alert("ERROR");
        });
    }
  }
};
</script>
